// extracted by mini-css-extract-plugin
export default {"btnWood":"Pagination_btnWood__w+54j","btnWoodActive":"Pagination_btnWoodActive__gwU+M"};